"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var BASE_KEY = 'customerDataCommunicator.videoConferencePlugin';

var FileManagerDeleteConfirmModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FileManagerDeleteConfirmModal, _PureComponent);

  function FileManagerDeleteConfirmModal() {
    (0, _classCallCheck2.default)(this, FileManagerDeleteConfirmModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileManagerDeleteConfirmModal).apply(this, arguments));
  }

  (0, _createClass2.default)(FileManagerDeleteConfirmModal, [{
    key: "render",
    value: function render() {
      var integrationName = _react.default.createElement(_FormattedMessage.default, {
        message: BASE_KEY + ".integrationName." + this.props.appName.toLowerCase()
      });

      return _react.default.createElement(_UIConfirmModal.default, {
        message: _react.default.createElement(_FormattedReactMessage.default, {
          message: BASE_KEY + ".confirmModalText",
          options: {
            integrationName: integrationName
          }
        }),
        onConfirm: this.props.onConfirm,
        onReject: this.props.onReject
      });
    }
  }]);
  return FileManagerDeleteConfirmModal;
}(_PureComponent2.default);

FileManagerDeleteConfirmModal.propTypes = (0, _extends2.default)({
  appName: _propTypes.default.string.isRequired
}, _PromptablePropInterface.default);

var _default = (0, _Promptable.default)(FileManagerDeleteConfirmModal);

exports.default = _default;
module.exports = exports.default;